<template>
  <div class="row">
    <div class="col-md-4">
      <div class="card" ref="refuelCard">
        <b-skeleton-wrapper :loading="isRefuelLoading">
          <template #loading>
            <div class="card-body">
              <b-skeleton width="85%"></b-skeleton>
              <b-skeleton width="55%"></b-skeleton>
              <b-skeleton width="70%"></b-skeleton>
            </div>
          </template>
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-8">
                <div class="d-flex flex-wrap">
                  <div>
                    <h5 class="mb-1">{{ $t('dashboard.title.refuelingTotal') }}</h5>
                    <p class="mb-0 font-size-10">
                      {{ momentDateShortMonth(refuelPeriod?.[0]) }} -
                      {{ momentDateShortMonth(refuelPeriod?.[1]) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="float-end">
                  <div class="mc-table-filter">
                    <div class="mc-table-view">
                      <b-dropdown dropleft variant="white">
                        <template v-slot:button-content>
                          <i class="mc-fa icon-outline_more-vertical"></i>
                        </template>
                        <b-dropdown-item @click="openDatepicker('refuel')">{{
                          $t('global.object.period')
                        }}</b-dropdown-item>
                        <mc-date-picker
                          v-show="isShow"
                          class="ms-2"
                          v-model="refuelPeriod"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMM YYYY"
                          value-type="YYYY-MM-DD"
                          :shortcuts="refuelShortcuts"
                          :draft="true"
                          :disabled="isLayoutEdit"
                          range-separator=" - "
                          range
                          :confirm="true"
                          :confirm-text="$t('global.action.apply')"
                          ref="refuelPeriodPicker"
                          @input="initData('refuel')"
                          :disabled-date="disabledRange"
                          @pick="pickDate"
                          :popup-style="{
                            position: 'fixed',
                            top: '50%',
                            left: '0',
                            right: '0',
                            margin: '0 auto',
                            padding: '20px',
                            width: 'fit-content',
                            transform: 'translateY(-50%)',
                          }"
                          :lang="datePickerLang"
                        >
                          <template #header>
                            <h5 class="text-center mc-general__label">
                              {{
                                `${$t('global.object.period')} ${$t(
                                  'dashboard.title.refuelingTotal'
                                )}`
                              }}
                            </h5>
                          </template>
                          <template #footer>
                            <b-button
                              class="mx-2"
                              variant="outline-primary"
                              @click="closeCalendar('refuel')"
                              >{{ $t('global.action.cancel') }}</b-button
                            >
                          </template>
                        </mc-date-picker>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <h4>{{ refuel.count }}</h4>
                <p>{{ $t('dashboard.text.refueling') }}</p>
              </div>
              <div class="col-md-4">
                <h4>{{ refuel.totalFuel }}</h4>
                <p>{{ $t('dashboard.text.litre') }}</p>
              </div>
              <div class="col-md-4">
                <h4>{{ refuel.totalFleet }}</h4>
                <p>{{ $t('global.fleet') }}</p>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card" ref="lossCard">
        <b-skeleton-wrapper :loading="isFuelLossLoading">
          <template #loading>
            <div class="card-body">
              <b-skeleton width="85%"></b-skeleton>
              <b-skeleton width="55%"></b-skeleton>
              <b-skeleton width="70%"></b-skeleton>
            </div>
          </template>
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-8">
                <div class="d-flex flex-wrap">
                  <div>
                    <h5 class="mb-1">{{ $t('dashboard.title.fuelLossAnomaly') }}</h5>
                    <p class="mb-0 font-size-10">
                      {{ momentDateShortMonth(fuelLossPeriod?.[0]) }} -
                      {{ momentDateShortMonth(fuelLossPeriod?.[1]) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="float-end">
                  <div class="mc-table-filter">
                    <div class="mc-table-view">
                      <b-dropdown dropleft variant="white">
                        <template v-slot:button-content>
                          <i class="mc-fa icon-outline_more-vertical"></i>
                        </template>
                        <b-dropdown-item @click="openDatepicker('fuelLoss')">{{
                          $t('global.object.period')
                        }}</b-dropdown-item>
                        <mc-date-picker
                          v-show="isShow"
                          class="ms-2"
                          v-model="fuelLossPeriod"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMM YYYY"
                          value-type="YYYY-MM-DD"
                          :shortcuts="fuelLossShortcuts"
                          :draft="true"
                          :disabled="isLayoutEdit"
                          range-separator=" - "
                          range
                          :confirm="true"
                          :confirm-text="$t('global.action.apply')"
                          ref="fuelLossPeriodPicker"
                          @input="initData('fuelLoss')"
                          :disabled-date="disabledRange"
                          @pick="pickDate"
                          :popup-style="{
                            position: 'fixed',
                            top: '50%',
                            left: '0',
                            right: '0',
                            margin: '0 auto',
                            padding: '20px',
                            width: 'fit-content',
                            transform: 'translateY(-50%)',
                          }"
                          :lang="datePickerLang"
                        >
                          <template #header>
                            <h5 class="text-center mc-general__label">
                              {{
                                `${$t('global.object.period')} ${$t(
                                  'dashboard.title.fuelLossAnomaly'
                                )}`
                              }}
                            </h5>
                          </template>
                          <template #footer>
                            <b-button
                              class="mx-2"
                              variant="outline-primary"
                              @click="closeCalendar('fuelLoss')"
                              >{{ $t('global.action.cancel') }}</b-button
                            >
                          </template>
                        </mc-date-picker>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <h4>{{ fuelLoss.count }}</h4>
                <p>{{ $t('dashboard.text.reduction') }}</p>
              </div>
              <div class="col-md-4">
                <h4>{{ fuelLoss.totalFuel }}</h4>
                <p>{{ $t('dashboard.text.litre') }}</p>
              </div>
              <div class="col-md-4">
                <h4>{{ fuelLoss.totalFleet }}</h4>
                <p>{{ $t('global.fleet') }}</p>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card" ref="foulCard">
        <b-skeleton-wrapper :loading="isFoulLoading">
          <template #loading>
            <div class="card-body">
              <b-skeleton width="85%"></b-skeleton>
              <b-skeleton width="55%"></b-skeleton>
              <b-skeleton width="70%"></b-skeleton>
            </div>
          </template>
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-8">
                <div class="d-flex flex-wrap">
                  <div>
                    <h5 class="mb-1">{{ $t('dashboard.title.violationTotal') }}</h5>
                    <p class="mb-0 font-size-10">
                      {{ momentDateShortMonth(foulPeriod?.[0]) }} -
                      {{ momentDateShortMonth(foulPeriod?.[1]) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="float-end">
                  <div class="mc-table-filter">
                    <div class="mc-table-view">
                      <b-dropdown dropleft variant="white">
                        <template v-slot:button-content>
                          <i class="mc-fa icon-outline_more-vertical"></i>
                        </template>
                        <b-dropdown-item @click="openDatepicker('foul')">{{
                          $t('global.object.period')
                        }}</b-dropdown-item>
                      </b-dropdown>
                      <mc-date-picker
                        v-show="isShow"
                        class="ms-2"
                        v-model="foulPeriod"
                        :placeholder="$t('global.action.selectDate')"
                        format="DD MMM YYYY"
                        value-type="YYYY-MM-DD"
                        :shortcuts="foulShortcuts"
                        :draft="true"
                        :disabled="isLayoutEdit"
                        range-separator=" - "
                        range
                        :confirm="true"
                        :confirm-text="$t('global.action.apply')"
                        ref="foulPeriodPicker"
                        @input="initData('foul')"
                        :disabled-date="disabledRange"
                        @pick="pickDate"
                        :popup-style="{
                          position: 'fixed',
                          top: '50%',
                          left: '0',
                          right: '0',
                          margin: '0 auto',
                          padding: '20px',
                          width: 'fit-content',
                          transform: 'translateY(-50%)',
                        }"
                        :lang="datePickerLang"
                      >
                        <template #header>
                          <h5 class="text-center mc-general__label">
                            {{
                              `${$t('global.object.period')} ${$t(
                                'dashboard.title.violationTotal'
                              )}`
                            }}
                          </h5>
                        </template>
                        <template #footer>
                          <b-button
                            class="mx-2"
                            variant="outline-primary"
                            @click="closeCalendar('foul')"
                            >{{ $t('global.action.cancel') }}</b-button
                          >
                        </template>
                      </mc-date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <h4>{{ foul.count }}</h4>
                <p>{{ $t('global.object.violation') }}</p>
              </div>
              <div class="col-md-6">
                <h4>{{ foul.totalFleet }}</h4>
                <p>{{ $t('global.fleet') }}</p>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import moment from 'moment'
import { GET_DASHBOARD_ALERT } from '@/services/api/dashboard/dashboard'
import datepickerShortcuts from '../lib/constants/date-picker-shortcuts'
import datePickerLang from '@/helpers/date-picker-lang'
import McDatePicker from '@/components/McDatePicker'
import { mapGetters } from 'vuex'
import { SENSOR_CODES } from '../../setting/tracker-sensor/lib/sensors'

moment.locale('id')

export default {
  components: { McDatePicker },
  mixins: [Helper],
  props: {
    isLayoutEdit: { type: Boolean, default: false },
  },
  data() {
    return {
      isRefuelLoading: false,
      isFuelLossLoading: false,
      isFoulLoading: false,
      refuelPeriod: [moment().subtract(6, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      fuelLossPeriod: [
        moment().subtract(6, 'd').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      foulPeriod: [moment().subtract(6, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      isShow: false,
      refuel: {
        count: 0,
        totalFuel: 0,
        totalFleet: 0,
      },
      fuelLoss: {
        count: 0,
        totalFuel: 0,
        totalFleet: 0,
      },
      foul: {
        count: 0,
        totalFleet: 0,
      },
      pastDate: moment().subtract(1, 'years'),
      futureEnd: moment().add(1, 'years'),
      refuelPicker: {},
      lossPicker: {},
      foulPicker: {},
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    refuelShortcuts() {
      return datepickerShortcuts(this, 'refuel-config', { alertCode: ['13'] })
    },
    fuelLossShortcuts() {
      return datepickerShortcuts(this, 'fuel-loss-config', { alertCode: ['14'] })
    },
    foulShortcuts() {
      return datepickerShortcuts(this, 'refuel-config', { alertCode: ['(8,23,24,25)'] })
    },
    datePickerLang() {
      return datePickerLang()
    },
  },
  mounted() {
    this.isRefuelLoading = true
    this.isFuelLossLoading = true
    this.isFoulLoading = true
    this.refuelPeriod = this.updatePeriodFromLocalStorage(
      'refuel-config',
      this.refuelPeriod,
      ['13'],
      this.refuelShortcuts
    )
    this.fuelLossPeriod = this.updatePeriodFromLocalStorage(
      'fuel-loss-config',
      this.fuelLossPeriod,
      ['14'],
      this.fuelLossShortcuts
    )
    this.foulPeriod = this.updatePeriodFromLocalStorage(
      'foul-config',
      this.foulPeriod,
      ['(8,23,24,25)'],
      this.foulShortcuts
    )
  },
  methods: {
    updatePeriodFromLocalStorage(configKey, period, defaultAlertCode, shortcuts) {
      let config = JSON.parse(localStorage.getItem(configKey))
      let result = []

      if (!config) {
        const startDate = moment(period[0] + ' 00:00:00.000').toISOString()
        const endDate = moment(period[1] + ' 23:59:59.000').toISOString()
        localStorage.setItem(
          configKey,
          JSON.stringify({
            startDate,
            endDate,
            alertCode: defaultAlertCode,
            isShortcut: false,
            index: 0,
          })
        )
        config = JSON.parse(localStorage.getItem(configKey))
      }
      if (config.isShortcut) {
        const generateDate = shortcuts[config.index].onClick()
        result[0] = this.momentYmD(generateDate[0])
        result[1] = this.momentYmD(generateDate[1])
      } else {
        result[0] = config.startDate == null ? period[0] : this.momentYmD(config.startDate)
        result[1] = config.endDate == null ? period[1] : this.momentYmD(config.endDate)
      }

      return result
    },
    openDatepicker(type) {
      if (type == 'refuel') {
        this.$refs.refuelPeriodPicker.openPopup()
      } else if (type == 'fuelLoss') {
        this.$refs.fuelLossPeriodPicker.openPopup()
      } else if (type == 'foul') {
        this.$refs.foulPeriodPicker.openPopup()
      }
    },
    closeCalendar(type) {
      if (type == 'refuel') {
        this.$refs.refuelPeriodPicker.cancel()
      } else if (type == 'fuelLoss') {
        this.$refs.fuelLossPeriodPicker.cancel()
      } else if (type == 'foul') {
        this.$refs.foulPeriodPicker.cancel()
      }
    },
    disabledRange: function (date) {
      return date <= this.pastDate || date >= this.futureEnd || date > new Date()
    },
    pickDate(date) {
      let maxDate = 30
      this.pastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)

      // Get the current date and time
      let currentDate = new Date()

      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000).getTime() === currentDate.getTime()) {
        this.futureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.futureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
    },
    async initData(type, vgroupId) {
      let filter = {}
      let config = {}
      if (type == 'refuel') {
        this.isRefuelLoading = true
        filter = {
          startDate: moment(this.refuelPeriod[0] + ' 00:00:00.000').toISOString(),
          endDate: moment(this.refuelPeriod[1] + ' 23:59:59.000').toISOString(),
          alertCode: ['13'],
          isShortcut: false,
          index: 0,
        }
        config = JSON.parse(localStorage.getItem('refuel-config'))
        if (!config.isShortcut) {
          localStorage.setItem('refuel-config', JSON.stringify(filter))
        }
      } else if (type == 'fuelLoss') {
        this.isFuelLossLoading = true
        filter = {
          startDate: moment(this.fuelLossPeriod[0] + ' 00:00:00.000').toISOString(),
          endDate: moment(this.fuelLossPeriod[1] + ' 23:59:59.000').toISOString(),
          alertCode: ['14'],
          isShortcut: false,
          index: 0,
        }
        config = JSON.parse(localStorage.getItem('fuel-loss-config'))
        if (!config.isShortcut) {
          localStorage.setItem('fuel-loss-config', JSON.stringify(filter))
        }
      } else if (type == 'foul') {
        this.isFoulLoading = true
        filter = {
          startDate: moment(this.foulPeriod[0] + ' 00:00:00.000').toISOString(),
          endDate: moment(this.foulPeriod[1] + ' 23:59:59.000').toISOString(),
          alertCode: ['(8,23,24,25)'],
          isShortcut: false,
          index: 0,
        }
        config = JSON.parse(localStorage.getItem('foul-config'))
        if (!config.isShortcut) {
          localStorage.setItem('foul-config', JSON.stringify(filter))
        }
      }
      const res = await this.$apollo.query({
        query: GET_DASHBOARD_ALERT,
        variables: {
          filter: {
            sensorCode: SENSOR_CODES.FUEL,
            startDate: filter.startDate,
            endDate: filter.endDate,
            alertCode: filter.alertCode,
            vgroupId,
            disabledOdoFuel: this.hasAccess(['b1x-new-fuel-expectation:read']),
          },
        },
        fetchPolicy: 'no-cache',
      })
      switch (type) {
        case 'refuel':
          this.refuel = {
            count: res.data.dashboardAlert.dashboardAlert[0].alertCount,
            totalFuel: res.data.dashboardAlert.dashboardAlert[0].alertData,
            totalFleet: res.data.dashboardAlert.dashboardAlert[0].vehicleCount,
          }
          setTimeout(() => {
            this.isRefuelLoading = false
          }, 200)
          break
        case 'fuelLoss':
          this.fuelLoss = {
            count: res.data.dashboardAlert.dashboardAlert[0].alertCount,
            totalFuel: res.data.dashboardAlert.dashboardAlert[0].alertData,
            totalFleet: res.data.dashboardAlert.dashboardAlert[0].vehicleCount,
          }
          setTimeout(() => {
            this.isFuelLossLoading = false
          }, 200)
          break
        case 'foul':
          this.foul = {
            count: res.data.dashboardAlert.dashboardAlert[0].alertCount,
            totalFleet: res.data.dashboardAlert.dashboardAlert[0].vehicleCount,
          }
          setTimeout(() => {
            this.isFoulLoading = false
          }, 200)
          break
        default:
          this.refuel = {}
          this.fuelLoss = {}
          this.foul = {}
          break
      }
    },
  },
}
</script>
